module.exports = __webpack_public_path__ + "img/sunlight-for-sunny.aa37b715.svg";